const strings = {
  login: {
    title: 'Login',
    description: 'Sign In to your account',
    submit: 'Submit',
    loginFailed:
      'Login failed. Please check the credentials or try after sometime.'
  },
  studentDetails: {
    addRegistrationForm: 'Add Student Registration Form',
    personalDetailsTitle: 'Personal Details',
    studentNameLabel: `Student's Name`,
    studentNamePlaceholder: 'Enter Student Name',
    genderLabel: 'Gender',
    genderPlaceholder: 'Select Gender',
    dobPlaceholder: 'Select Date Of Birth',
    enterDob: 'MM-DD-YYYY',
    dobLabel: 'Date of Birth',
    enrollmentNumberLabel: 'Enrollment Number',
    enterEnrollment: 'Enter Enrollment Number',
    nationalityPlaceholder: 'Select Nationality',
    nationalityLabel: 'Nationality',
    communityPlaceholder: 'Select Community',
    communityLabel: 'Community',
    religionPlaceholder: 'Enter Religion',
    religionLabel: 'Religion',
    castePlaceholder: 'Select Caste',
    casteLabel: 'Caste',
    studentTypeLabel: 'Student Type',
    studentTypePlaceholder: 'Select Student Type',
    physicallyChallengedLabel: 'Is Physically Challenged',
    aadharNumberPlaceHolder: 'Enter Aadhar Number',
    aadharNumberLabel: 'Aadhar Number',
    userNameLabel: 'User Name',
    userNamePlaceholder: 'Enter User Name',
    passwordLabel: 'Password',
    passwordPlaceHolder: 'Enter Password',
    communictionDetailsTitle: 'Communiction Details',
    addressLabel: 'Address for Communication',
    addressPlaceholder: 'Enter Address',
    parentMobileNumberLabel: 'Parent Mobile Number',
    parentMobileNumberPlaceholder: 'Enter Parent Mobile Number',
    emailLabel: 'Email Label',
    emailPlaceholder: 'Enter email Id',
    stateLabel: 'State',
    statePlaceholder: 'Select State',
    districtLabel: 'District',
    districtPlaceholder: 'Enter District',
    talukLabel: 'Taluk',
    talukPlaceholder: 'Enter Taluk',
    cityLabel: 'City/Town/Suburban',
    cityPlaceholder: 'Enter City/Town/Suburban',
    countryLabel: 'Country',
    countryPlaceholder: 'Enter Country',
    postalLabel: 'Postal/Zipcode',
    postalPlaceholder: 'Enter Postal/Zipcode',
    qualifyingExamDetailsTitle: 'Qualifying Exam Details',
    mediumLabel: 'Medium',
    mediumPlaceholder: 'Select Medium',
    previousExamLabel: 'Previous Exam registration No',
    previousExamPlaceholder: 'Enter Previous Exam registration No',
    satsNoLabel: 'SATS No',
    satsPlaceholder: 'Enter SATS No',
    boardLabel: 'Board',
    boardPlaceholder: 'Select Board',
    schoolLabel: 'School/ College Last Attended',
    schoolPlaceholder: 'Enter School/ College Last Attended',
    yearOfPassingLabel: 'Year Of Passing',
    yearOfPassingPlaceholder: 'Enter Year of Passing',
    obtainMarksLabel: 'Obtain Marks',
    obtainMarksPlaceholder: 'Enter Obtain Marks',
    percentagelabel: 'Percentage',
    percentagePlaceholder: 'Enter Percentage',
    courseDetailsTitle: `Course Details`,
    admisionTypeLabel: 'Admission Type',
    admissionTypePlaceholder: 'Select Admission Type',
    primaryLanguage: 'I - Language',
    secondaryLanguage: 'II - Language',
    languagePlaceholder: 'Select Language',
    instituteName: 'Institute',
    selectInstituteName: 'Select Institute',
    branchName: 'Branch',
    selectBranch: 'Select Branch',
    batch: 'Batch',
    selectBatch: 'Select Batch',
    course: 'Course',
    selectCourse: 'Select Course',
    status: 'Status',
    selectStatus: 'Select Status',
    acedemicTypeLabel: 'Acedemic Type',
    acedemicTypePlaceholder: 'Select Year',
    fatherNameLabel: 'Father Name',
    motherNameLabel: 'Mother Name',
    fatherNamePlaceholder: 'Enter Father Name',
    motherNamePlaceholder: 'Enter Mother Name'
  },
  resetPassword: {
    title: 'Reset Password',
    description: "Don't worry, happens to the best of us",
    submit: 'Submit',
    backToLogin: 'Back to Login'
  },
  register: {
    title: 'Book your Free Class',
    noAccount: "Don't have an account yet?",
    registerFailed: 'User has already registered, Please try log in!',
    completeRegistrationFailed:
      'Failed to register the user, Please try again later!',
    backToLogin: 'Back to Login',
    enterOtp: 'Enter the OTP you received via SMS',
    signUp: 'SignUp',
    submit: 'Submit',
    buy: 'Buy',
    benefitsOffered: 'Benefits Offered',
    getTrial: 'Get Trial',
    continueBtn: 'Continue',
    student: 'Student',
    institute: 'Institute / Coaching Center',
    package: {
      student: {
        title: 'Student Package',
        note: 'Each Package contains 100 Tests with Learn Module'
      }
    },
    benefits: {
      learnModuleAccess: 'Learn Module Access',
      liveModuleAccess: 'Live Module Access',
      testModuleAccess: 'Test Module Access'
    }
  },
  validationMessages: {
    userName: {
      required: 'Username is required'
    },
    dob: 'MM-DD-YYYY',
    phone: {
      required: 'Phone number is required',
      numberOnly: 'Please enter only numbers',
      invalid: 'Please enter valid phone number'
    },
    email: {
      required: 'Email is required',
      invalid: 'Please enter valid email'
    },
    password: {
      required: 'Password is required',
      confirmPasswordRequired: 'Confirm Password is required',
      invalid:
        'Password must contain 8 characters, One uppercase, One lowercase, One number and one special case character',
      nonMatch: 'Passwords must match'
    },
    field: {
      required: 'Field is required'
    },
    batch: {
      selectInstitute: 'Select an Institute',
      selectBranch: 'Select a Branch',
      selectCourse: 'Select a Course',
      selectMaterial: 'Select a Material',
      selectStaus: 'Select a valid Status',
      saveBatchFailed: 'Error occured while saving the batch',
      deleteBatchFailed: 'Error Occured while deleting the batch'
    },
    course: {
      deleteCourseFailed: 'Error Occured while deleting the course',
      saveError: 'Error occured while saving the course'
    },
    session: {
      selectInstitute: 'Select an Institute',
      selectBranch: 'Select a Branch',
      selectCourse: 'Select a Course',
      selectBatch: 'Select a Batch',
      selectSubject: 'Select a Subject',
      selectTeacher: 'Select a Teacher',
      selectPlatform: 'Select a Platform',
      saveSessionFailed: 'Error occured while saving the session'
    }
  },
  learn: {
    title: 'Learn',
    helpText: 'What do you want to learn today?',
    chapters: 'chapters',
    videos: 'videos',
    topics: 'topics',
    materials: 'materials',
    synopsis: 'synopsis',
    failedTofetchChapters: 'Unable to fetch chapters. Please try again.'
  },
  live: {
    upComingSession: 'Up Coming Session',
    liveSession: 'Live Session',
    completedSession: 'Completed Session',
    joinSession: 'Join Session',
    sessionLabel: 'Session',
    date: 'Date',
    startTime: 'Start Time'
  },
  header: {
    logout: 'Logout'
  },
  menu: {
    student: {
      learn: 'Learn',
      live: 'Live',
      assessment: 'Assessment',
      practiceTest: 'Practice Test',
      webcam: 'Scan Book',
      dailyTest: 'Daily Test'
    },
    admin: {
      qrCode: {
        list: {
          title: 'QR Code list',
          search: 'Search for subject',
          assignCourseModal: 'Assign Course'
        }
      },
      or: 'OR',
      user: 'User',
      superAdmin: 'Super Admin',
      branchAdmin: 'Branch Admin',
      institudeAdmin: 'Institute Admin',
      teacher: 'Teacher',
      student: 'Student',
      dashboard: 'Dashboard',
      adminMaterial: 'Material',
      institute: 'Institute',
      institueList: 'Institute Listing',
      addInstitute: 'Add Institute',
      editInstitute: 'Edit Institute',
      addCoachingCenterBranch: 'Add Branch',
      editCoachingCenterBranch: 'Edit Branch',
      selectCourses: 'Select Upmyranks Courses',
      dateFormat: 'dd/mm/yyyy',
      publishMaterial: 'Publish Material',
      assignment: 'Assignment',
      assignmentStartDate: 'Assignment Start Date',
      session: 'Session',
      sessionType: 'Session Type',
      sessionName: 'Session Name',
      sessionList: 'Session Listing',
      createSession: 'Create Session',
      editSession: 'Edit Session',
      chapterPublish: 'Chapter Publish',
      list: 'List',
      publish: 'Publish',
      unPublish: 'Unpublish',
      create: 'Create',
      superAdminList: 'Super Admin List',
      instituteName: 'Institute Name',
      branchName: 'Branch Name',
      batchName: 'Batch Name',
      selectCourse: 'Select Course',
      selectBranch: 'Select Branch',
      selectBatch: 'Select Batch',
      selectSubject: 'Select Subject',
      selectChapter: 'Select Chapter',
      selectTopic: 'Select Topic',
      noOfQuestions: 'No Of Questions',
      enterNoOfQuestions: 'Enter no of Questions',
      showAdvanceFilter: 'Show Advance Filter',
      hideAdvanceFilter: 'Hide Advance Filter',
      selectMaterial: 'Select Material',
      selectTeacher: 'Select Teacher',
      selectDate: 'Select Date',
      to: 'To',
      startTime: 'Start Time',
      selectPlatform: 'Select Platform',
      selectZoomUser: 'Select Zoom User',
      reset: 'Reset',
      selectAllotedWebexUser: 'Select Alloted Webex User',
      selectCustomWebexUser: 'Select Custom Webex User',
      endTime: 'End Time',
      publishDate: 'Publish Date',
      publishTiming: 'Publish Timing',
      dashboardMenu: {
        title: 'Super Admin DashBoard',
        coachingCenters: 'Coaching centers',
        branches: 'Branches',
        batched: 'Batches',
        teachers: 'Teachers',
        students: 'Students'
      },
      branchAdminList: 'Branch Admin List',
      instituteAdminList: 'Institute Admin List',
      teacherList: 'Teacher List',
      studentList: 'Student List',
      studentActivity: 'Student Activity',
      course: 'Course',
      previous: 'Previous',
      next: 'Next',
      totalNoOfSuperAdmin: 'Total Number of Super Admin = ',
      addSuperAdmin: 'Add Super admin',
      totalNoOfBranchAdmin: 'Total Number of Branch Admin = ',
      addBranchAdmin: 'Add Branch admin',
      totalNoOfInstituteAdmin: 'Total Number of Institute Admin = ',
      addInstituteAdmin: 'Add Institute admin',
      totalNoOfStudents: 'Total Number of Students = ',
      addStudent: 'Add Student',
      bulkEntry: 'Bulk Entry',
      totalNoOfTeachers: 'Total Number of Teachers = ',
      addTeacher: 'Add Teacher',
      questionListing: 'Question Listing',
      questionBank: 'Question Bank',
      addQuestion: 'Add Question',
      showAllFilter: 'Show All Filters',
      selectAll: 'Select All',
      courseName: 'Course Name',
      subjectName: 'Subject Name',
      chapterName: 'Chapter Name',
      selectClass: 'Select Class',
      className: 'Class name',
      selectLevel: 'Select Level',
      questionType: 'Question type',
      sortBy: 'Sort By',
      selectSortBy: 'Select Sort By',
      fetchQuestion: 'Fetch Question',
      selectQuestion: 'Select Question Type',
      topicName: 'Topic Name',
      notPublishedYet: 'Not Published Yet',
      createTest: {
        title: 'Create Test',
        testSetting: 'Test Settings',
        testName: 'Test Name',
        testCode: 'Test Code',
        attempts: 'Attempts',
        instructions: 'Instructions',
        testAddedSuccessfully: 'Questions added successfully!',
        enterSectionName: 'Enter section name',
        startQuestionPosition: 'Enter start question position',
        endQuestionPosition: 'Enter end question position',
        createSection: 'Create your first section',
        createSectionDescription:
          'Go ahead, and create your first section for this test.',
        testListing: 'Test Listing',
        newlyAddedList: 'Newly Added Test',
        assignedTest: 'Assigned Test',
        testList: 'Test List',
        testResults: 'Test Results',
        selectTestType: 'Select Test Type',
        selectStatus: 'Select Status',
        pendingRequests: 'Pending Requests',
        evaluate: 'Evaluate Exams',
        reviewQuestions: 'Review Questions',
        awardedMarks: 'Awarded Marks',
        maximumMarks: 'Maximum Marks',
        timeTaken: 'Time taken by student',
        reportedBy: 'Reported By: ',
        answer: 'Submitted Answer: ',
        reportedAnswer: 'Reported Answer: '
      },
      materialListing: 'Material Listing',
      selectCoachingCenter: 'Select Coaching Center '
    },
    lessonPlane: {
      title: 'Lesson Plan'
    },
    branch: {
      title: 'Branch',
      add: 'Add Branch',
      branchListing: 'Branch Listing',
      selectCoachingCenter: 'Select Coaching Center',
      selectBranch: 'Select Branch'
    },
    batch: {
      title: 'Batch',
      add: 'Add Batch',
      batchListing: 'Batch Listing',
      editBatch: 'Edit Batch',
      viewBatch: 'View Batch'
    },
    list: 'List',
    material: {
      add: 'Add Material',
      selectMaterial: 'Select Material Type',
      material: 'Material',
      sequence: 'Sequence',
      title: 'Title',
      chatUrl: 'Chat Url',
      videoUrl: 'Video Url'
    },
    leave: {
      title: 'Manage Leave',
      apply: 'Apply Leave',
      details: 'Leave Details',
      leaveMasterDetails: 'Leave Status',
      selectStatus: 'Select Status',
      leaveMaster: 'Leave Master',
      create: 'Apply Leave',
      qrcode: 'QR Generator',
      qrList: 'List'
    },
    course: {
      title: 'Course',
      add: 'Add Course',
      edit: 'Edit Course',
      courseListing: 'Course Listing',
      CoachingCenterName: 'CoachingCenter Name',
      description: 'Description',
      status: 'Status',
      placeholders: {
        selectParentCourse: 'Select Parent Course',
        selectCoachingCenter: 'Select CoachingCenter',
        selectOption: 'Select Option'
      },
      modal: {
        title: 'Are you sure to delete this course?'
      },
      view: {
        courseName: 'Course Name',
        parentCourse: 'Parent Course',
        description: 'Description',
        status: 'Status'
      }
    },
    learnSession: {
      title: 'Learn Session',
      add: 'Add Session',
      sessionNameLabel: 'Session Name',
      placeholder: {
        sessionName: 'Enter Session Name',
        selectFaculty: 'Select Faculty',
        selectAssignDate: 'Select Assign Date',
        selectChapter: 'Select Chapter',
        selectSubject: 'Select Subject',
        selectTopic: 'Select Topic',
        selectCourse: 'Select Course'
      },
      assignSession: {
        title: 'Assign Session',
        faculty: 'Faculty',
        assignDate: 'Assign Date',
        course: 'Course',
        chapter: 'Chapter',
        subject: 'Subject',
        topic: 'Topic'
      }
    },
    bulkEntry: {
      uploadError: 'Unable to add bulk entry. Please try again later.',
      selectBranchError: 'Please select coaching centre and branch to continue.'
    }
  },
  assessment: {
    overallPerformance: 'Overall Performance',
    scheduledTests: 'Scheduled Tests',
    attemptedTests: 'Attempted Tests',
    yourAverageScore: 'Your Average Score:',
    classAveragescore: 'Class Average Score:',
    topperAverageScore: 'Topper Average Score:',
    yourOverAllRank: 'Your Overall Rank',
    fullLength: 'Full Length',
    sectionWise: 'Section Wise',
    chapterWise: 'Chapter Wise',
    mock: 'Mock'
  },
  test: {
    question: 'Question:',
    jumpToQuestion: 'Jump to Question',
    timeRemaining: 'Times Remaining',
    completed: 'Completed',
    previous: 'Previous',
    next: 'Next',
    submit: 'Submit',
    markReview: 'Mark for review',
    duration: 'Duration',
    enterDuration: 'Enter Duration in Mins',
    notes: 'Notes',
    takeTest: 'Take Test',
    result: 'Result',
    pending: 'Pending',
    unblock: 'Unblock',
    instructions: 'Instructions',
    questions: 'Questions',
    attempt: 'Attempt',
    marked: 'Marked for Review',
    read: 'Read',
    unRead: 'Unread',
    currentRank: 'Current Rank',
    leaderBoard: 'LeaderBoard',
    score: 'Score',
    yourScore: 'Your Score',
    correct: 'Correct',
    inCorrect: 'Incorrect',
    unAnswered: 'Unanswered',
    accuracy: 'Accuracy',
    performance: 'Performance',
    timeTakenByYou: 'Time taken by you',
    timeTakenByTopper: 'Time taken by topper',
    questionNumbers: 'Question Numbers',
    totalTimeTaken: 'Total Time Taken',
    averageTimeTaken: 'Avg Time Per Question',
    toppersTimeTaken: `Topper's Total Time Taken`,
    yourAnswer: 'Your Answer: ',
    sectionName: 'Section Name: ',
    difficultyLevel: 'Difficulty Level: ',
    timeInSeconds: 'Time in Seconds',
    report: 'Report',
    practiceTest: 'Practice Mode',
    practiceTestHelperText: `Taking a practice test gives you a baseline for understanding where you're starting from.`
  },
  studentQR: {
    orScanner: 'QR Book Scanner',
    qrLogoAlt: 'QR Logo',
    playVideo: 'Play Video',
    pleaseWait: 'Please Wait...',
    buttonClick: "Click to Scan QRCode",
    video: 'Video'
  },
  modal: {
    test: {
      title: 'Submit Your Exam ?',
      subTitle: 'Once you submit the exam, you can not edit the answers'
    },
    otp: {
      title: 'SMS Verification',
      helpText: "Didn't receive the verification OTP?",
      resendAgain: 'Resend again'
    },
    deleteRecord: 'Are you sure you want to delete this record?',
    cancel: 'Cancel',
    submit: 'Submit',
    verify: 'Verify'
  },
  userDetail: {
    userType: 'User Type ',
    salutation: 'Salutation ',
    lastName: 'Last Name ',
    userName: 'User Name ',
    firstName: 'First Name ',
    fatherName: 'Father Name ',
    qualification: 'Qualification ',
    mobileNumber: 'Mobile Number ',
    email: 'Email ',
    dob: 'Dob ',
    address1: 'Address1 ',
    address2: 'Address2 ',
    password: 'Password',
    country: 'Country ',
    state: 'State ',
    city: 'City ',
    zipcode: 'Zip Code ',
    status: 'Status ',
    profileImage: 'Profile Image ',
    instituteName: 'Institute Name',
    branchName: 'Branch Name',
    subjectName: 'Subject Name',
    yearOfExperience: 'Year Of Experience',
    enrollmentNumber: 'Enrollment Number'
  },
  button: {
    back: 'Back',
    save: 'Save',
    apply: 'Apply',
    approve: 'Approve',
    reject: 'Reject',
    cancel: 'Cancel',
    evaluate: 'Evaluate',
    review: 'Review',
    done: 'Done',
    selectAll: 'Select All',
    dSelectAll: 'Deselect All',
    proceed: 'Proceed',
    createSectionText: 'Create Section',
    skipSectionText: 'Skip this step',
    download: 'Download',
    assign: 'Assign'
  },
  instituteDetails: {
    instituteNameLabel: 'Institute Name',
    mobileNumberLabel: 'Mobile Number',
    emailLabel: 'Email',
    expiresOnLabel: 'Expiry On',
    statusLabel: 'Status',
    address1Label: 'Address1',
    address2Label: 'Address2',
    countryLabel: 'Country',
    stateLabel: 'State',
    cityLabel: 'City',
    zipcodeLabel: 'Zip Code',
    institueCodeLabel: 'Institute Code',
    institueExpiresOnLabel: 'Institute Expiry On',
    questionLimitLabel: 'Question Limit',
    upmyranksCoursesLabel: 'Upmyranks Courses',
    studentCreationLimitLabel: 'Student Creation Limit',
    teacherCreationLimitLabel: 'Teacher Creation Limit',
    selectOptionLabel: 'Select an Option'
  },
  sessionDetails: {
    sessionNameLabel: 'Session Name',
    topicLabel: 'Topic',
    subjectNameLabel: 'Subject Name',
    courseNameLabel: 'Course Name',
    batchLabel: 'Batch',
    branchNameLabel: 'Branch Name',
    instituteLabel: 'Institute',
    dateLabel: 'Date',
    startTimeLabel: 'Start Time',
    endTimeLabel: 'End Time',
    statusLabel: 'Status'
  },
  leaveDetails: {
    selectLeaveType: 'Select Leave Type',
    selectReason: 'Select Reason',
    type: 'Leave Type',
    fromDate: 'From Date',
    toDate: 'To Date',
    name: 'Leave Name',
    description: 'Leave Description',
    encashable: 'Encashable',
    status: 'Day Status',
    actionLabel: 'Action',
    selectDayStatus: 'Select Day Status',
    remarks: 'Remarks'
  },
  branchDetails: {
    instituteName: 'Institute Name ',
    branchName: 'Branch Name ',
    selectWebexUser: 'Select Webex User ',
    address1: 'Address1 ',
    address2: 'Address2 ',
    country: 'Country ',
    state: 'State ',
    city: 'City ',
    zipcode: 'Zip Code ',
    mobileNumber: 'Mobile Number ',
    email: 'Email ',
    institueCode: 'Institute Code',
    institueExpiresOn: 'Institute Expiry On',
    mainBranch: 'Main Branch ',
    questionLimit: 'Question Limit ',
    availableCourses: 'Available Courses ',
    status: 'Status ',
    placeholders: {
      selectCoachingCenter: 'Select Coaching Center ',
      selectOption: 'Select an Option'
    }
  },
  batchDetails: {
    batchName: 'Batch Name',
    instituteName: 'Institute Name ',
    branchName: 'Branch Name',
    courseName: 'Course Name',
    upmyranksMaterial: 'Upmranks Material',
    publishDate: 'Publish Date',
    batchStartDate: 'Batch Start Date',
    batchEndDate: 'Batch End Date',
    startTiming: 'Start Timing',
    endTiming: 'End Timing',
    batchSize: 'Batch Size',
    status: 'Status ',
    description: 'Description',
    placeholders: {
      selectInstitute: 'Select Institute',
      selectCourseName: 'Select Course',
      selectUpmyranksMaterial: 'Select Upmyranks Material',
      selectAnOption: 'Select an Option',
      selectBranchName: 'Select Branch',
      selectBatch: 'Select Batch'
    }
  },
  fileUpload: {
    dragAndDropText: 'DRAG AND DROP FILE TO UPLOAD',
    upload: 'Upload File',
    docFilesOnly: 'UPLOAD ONLY .DOC FILES',
    imageOnly: 'UPLOAD ONLY .PNG/.JPG FILES',
    assignment: 'UPLOAD ONLY .PDF,.DOCX,.JPG,.JPEG,.SVG,.PNG FILES'
  },
  pendingRequests: {
    approve: {
      title: 'Unlock Exam(s)',
      description:
        'Out of 180 minutes, 0 minutes has already spent and 180 minutes remaining. To change the remaining time enter the new remaining time (in minutes) below:'
    },
    reject: {
      title: 'Rejecting Request',
      description: 'Are you sure you want to reject this request?'
    }
  },
  error: {
    addMaterialFailed: 'Error While Uploading the Material',
    downloadStudentActivityFailed: 'Error while downloading student activity',
    unableToAssignQrCode: 'Unable to assign Qrcode. Please try again later.'
  }
}

export default strings
